import { Fab, Tooltip } from "@mui/material";
import { keyframes } from "@mui/system";
// import { keyframes } from "@emotion/react";
import RefreshIcon from "@mui/icons-material/Refresh";
import { useQueryClient, useIsFetching } from "@tanstack/react-query";

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const RefreshButton = ({ setSelectedConfigs }) => {
  const queryClient = useQueryClient();
  const isFetching = useIsFetching();

  return (
    <Tooltip title="Refresh Page">
      <Fab
        color="primary"
        aria-label="refresh page"
        sx={{ position: "absolute", right: 24 }}
        size="small"
        onClick={async () => {
          // setSelectedView(null);
          // await queryClient.invalidateQueries({ queryKey: ["calenderConfig"] });
          setSelectedConfigs([]);
          await queryClient.invalidateQueries({ queryKey: ["eventConfigArray"] });
          queryClient.removeQueries({ queryKey: ["eventArray"] });
        }}
      >
        <RefreshIcon sx={isFetching ? { animation: `${spin} 0.8s linear infinite` } : {}} />
      </Fab>
    </Tooltip>
  );
};
